export function formatTinesUnits(units: number): string {
  const rounded =
    units >= 100 ? Math.round(units) : Math.round(units * 10) / 10;
  return rounded.toLocaleString(undefined, { maximumFractionDigits: 1 });
}
